// extracted by mini-css-extract-plugin
module.exports = {"fade":"Fade_fade__Bvb2N","overflow-hidden":"Fade_overflow-hidden__JIwoa"};